import React from "react";
import Logo from "../../images/logo.svg";
import { Base, Text } from "../../styles";
import styled from "styled-components";
import ContentGutter from "../ContentGutter";
const FooterWrapper = styled(Base)({});
const LogoWrapper = styled(Base)({
  display: "inline-block"
});
const FooterCopy = styled(Text)({
  display: "inline-block",
  color: "#fff",
  textDecoration: "none",
  lineHeight: "20px"
});
const FooterLink = styled(Text)({
  display: "inline-block",
  color: "#fff",
  textDecoration: "none",
  lineHeight: "20px",
  cursor: "pointer"
});
function openCookiePreferences() {
  if (window.OneTrust) {
    window.OneTrust.ToggleInfoDisplay();
  }
}
const Footer = () => {
  return /* @__PURE__ */ React.createElement(FooterWrapper, {
    as: "footer",
    bg: "black",
    color: "white"
  }, /* @__PURE__ */ React.createElement(ContentGutter, null, /* @__PURE__ */ React.createElement(Base, {
    as: "div",
    p: ["32px 0", "32px 0", "50px 0"],
    gridTemplateColumns: [
      "1fr",
      "1fr 1fr",
      "max-content minmax(1fr,550px)"
    ],
    gridTemplateRows: ["1fr 1fr", "auto"],
    display: "grid",
    gridColumnGap: "10px",
    gridRowGap: "20px",
    justifyContent: ["space-between"],
    justifyItems: ["center", "unset"]
  }, /* @__PURE__ */ React.createElement(Base, {
    as: "div",
    gridTemplateColumns: ["300px"],
    gridTemplateRows: ["max-content max-content"],
    justifyItems: ["center"],
    display: "grid",
    gridColumnGap: "10px",
    gridRowGap: "20px"
  }, /* @__PURE__ */ React.createElement(LogoWrapper, {
    as: "div",
    width: "150px"
  }, /* @__PURE__ */ React.createElement(Logo, null)), /* @__PURE__ */ React.createElement(Base, {
    as: "div",
    textAlign: ["center"]
  }, /* @__PURE__ */ React.createElement(FooterCopy, {
    as: "p",
    variant: "xx-small"
  }, "Kawasaki Motor Corp., U.S.A."), /* @__PURE__ */ React.createElement(FooterCopy, {
    as: "p",
    variant: "xx-small"
  }, "P.O. Box 888285, Grand Rapids, MI 49588"))), /* @__PURE__ */ React.createElement(Base, {
    as: "div",
    textAlign: ["center", "right"],
    display: "flex",
    flexWrap: "wrap",
    gridColumnGap: "10px",
    gridRowGap: "5px",
    justifyContent: ["center", "end"],
    alignContent: "center"
  }, /* @__PURE__ */ React.createElement(FooterCopy, {
    as: "a",
    variant: "xx-small",
    href: "https://www.kawasakienginesusa.com/privacy-policy.html"
  }, "Privacy Policy"), /* @__PURE__ */ React.createElement(FooterCopy, {
    as: "span",
    variant: "xx-small"
  }, " ", "|", " "), /* @__PURE__ */ React.createElement(FooterCopy, {
    as: "a",
    variant: "xx-small",
    href: "https://www.kawasakienginesusa.com/legal-notices/terms-and-conditions-use-kawasaki-motors-corp-usa-websites.html"
  }, "Terms and Conditions of Use"), /* @__PURE__ */ React.createElement(FooterCopy, {
    as: "span",
    variant: "xx-small"
  }, " ", "|", " "), /* @__PURE__ */ React.createElement(FooterCopy, {
    as: "a",
    variant: "xx-small",
    href: "https://www.kawasakienginesusa.com/ccpa.html"
  }, "California Privacy Policy"), /* @__PURE__ */ React.createElement(FooterCopy, {
    as: "span",
    variant: "xx-small"
  }, " ", "|", " "), /* @__PURE__ */ React.createElement(FooterCopy, {
    as: "a",
    variant: "xx-small",
    href: "https://privacyportal.onetrust.com/webform/045ffde2-647c-41d8-8fd2-848407f04871/15c56c27-7325-4414-b115-28163f6dbc52"
  }, "Do Not Sell My Personal Information"), /* @__PURE__ */ React.createElement(FooterCopy, {
    as: "span",
    variant: "xx-small"
  }, " ", "|", " "), /* @__PURE__ */ React.createElement(FooterCopy, {
    as: "a",
    variant: "xx-small",
    href: "https://www.kawasakienginesusa.com/legal-notices/kawasaki-trademarks.html"
  }, "Kawasaki Trademark"), /* @__PURE__ */ React.createElement(FooterCopy, {
    as: "span",
    variant: "xx-small"
  }, " ", "|", " "), /* @__PURE__ */ React.createElement(FooterCopy, {
    as: "a",
    variant: "xx-small",
    href: "https://www.kawasakienginesusa.com/legal-notices/legal-copy.html"
  }, "Legal Copy"), /* @__PURE__ */ React.createElement(FooterCopy, {
    as: "span",
    variant: "xx-small"
  }, " ", "|", " "), /* @__PURE__ */ React.createElement(FooterCopy, {
    as: "a",
    variant: "xx-small",
    href: "https://www.kawasakienginesusa.com/legal-notices/accessibility-statement.html"
  }, "Accessibility Statement"), /* @__PURE__ */ React.createElement(FooterCopy, {
    as: "span",
    variant: "xx-small"
  }, " ", "|", " "), /* @__PURE__ */ React.createElement(FooterCopy, {
    as: "a",
    variant: "xx-small",
    href: "https://www.kawasakienginesusa.com/privacy-policy.html#section11"
  }, "About Ads"), /* @__PURE__ */ React.createElement(FooterCopy, {
    as: "span",
    variant: "xx-small"
  }, " ", "|", " "), /* @__PURE__ */ React.createElement(FooterLink, {
    as: "a",
    variant: "xx-small",
    onClick: openCookiePreferences
  }, "Manage Cookie Preferences"))), /* @__PURE__ */ React.createElement("div", {
    className: "ctct-inline-form",
    "data-form-id": "2f2ff90e-002d-419f-96c7-b80a82d336c5"
  })));
};
export default Footer;
